/**
 * Initialize safe area CSS based on browser capabilities
 * This must be called early in the app lifecycle
 */
import { detectBrowser } from './browserUtils';

export const initSafeAreaCSS = () => {
  const browser = detectBrowser();
  
  // Only apply safe area insets for non-WeChat desktop browsers
  if (!browser.isWechatDesktop) {
    const style = document.createElement('style');
    style.textContent = `
      html, body {
        padding-top: env(safe-area-inset-top) !important;
        padding-bottom: env(safe-area-inset-bottom) !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // For WeChat desktop, ensure no safe area padding
  if (browser.isWechatDesktop) {
    const style = document.createElement('style');
    style.textContent = `
      html, body {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
      }
    `;
    document.head.appendChild(style);
  }
};